<script>
  import { Switch } from 'element-ui'
  export default {
    name: 'FormItemSwitch',
    extends: Switch,
  }
</script>
